import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-4,0h0.5v0.5h-0.5zM2.5,0h1.5v0.5h-1.5zM-4,0.5h1v0.5h-1zM-2.5,0.5h2v0.5h-2zM1,0.5h1v0.5h-1zM2.5,0.5h1v0.5h-1zM-4,1h3.5v0.5h-3.5zM0,1h3.5v0.5h-3.5zM-2,1.5h4v0.5h-4z',
    },
    {
      paint: 'epicMarble',
      d: 'M-3,-2h2v0.5h-2zM1.5,-2h1v0.5h-1zM-3.5,-1.5h2v0.5h-2zM1.5,-1.5h1.5v0.5h-1.5zM-4,-1h2v0.5h-2zM2,-1h1.5v0.5h-1.5zM-4,-0.5h1v0.5h-1zM3,-0.5h1v0.5h-1z',
    },
    { paint: 'water', d: 'M-2,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM-1.5,-0.5h3v0.5h-3z' },
    {
      paint: 'epicCrystal',
      d: 'M-0.5,-12h1v0.5h-1zM-1,-11.5h1.5v0.5h-1.5zM-2.5,-11h3.5v0.5h-3.5zM-3,-10.5h4v0.5h-4zM1.5,-10.5h1.5v0.5h-1.5zM-3,-10h6.5v0.5h-6.5zM-3.5,-9.5h7v0.5h-7zM-3.5,-9h1v0.5h-1zM-1.5,-9h1.5v0.5h-1.5zM0.5,-9h3v0.5h-3zM-1,-8.5h1v5.5h-1zM0.5,-8.5h1.5v0.5h-1.5zM3,-8.5h0.5v0.5h-0.5zM0.5,-8h1v6h-1zM-1.5,-3h1v1h-1zM-1,-2h0.5v0.5h-0.5zM1,-2h0.5v1.5h-0.5zM-1.5,-1.5h1v1h-1zM-3,-0.5h1.5v0.5h-1.5zM1.5,-0.5h1.5v0.5h-1.5zM-3,0h5.5v0.5h-5.5zM-0.5,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'snowCap', d: 'M0,-9h0.5v6h-0.5zM-0.5,-3h1v1h-1zM-0.5,-2h1.5v1.5h-1.5z' },
    {
      paint: 'waterLight',
      d: 'M-3,-8h0.5v0.5h-0.5zM-3.5,-7.5h1v1h-1zM-4,-6.5h1.5v0.5h-1.5zM2.5,-6.5h0.5v0.5h-0.5zM2.5,-6h1v0.5h-1zM2,-5.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M-3.5,0h0.5v0.5h-0.5zM-3,0.5h0.5v0.5h-0.5zM2,0.5h0.5v0.5h-0.5zM-0.5,1h0.5v0.5h-0.5z',
    },
  ],
  pixels: 254,
};
export const sprites: readonly PixelSprite[] = [variant0];
